<div class="card-detector">
  <div class="card-input-container">
    <!-- Input con la máscara dinámica -->
    <mat-form-field style="width: 100%;" >
      <input
        #cardInput
        matInput
        id="cardNumber"
        type="text"
        style="text-align: center;"
        autocomplete="off"
        [ngModel]="cardNumber"
        (input)="onCardNumberChange(cardInput.value)"
        placeholder="Ingresa el número de la tarjeta"
        [mask]="maskPattern" />
    </mat-form-field>
    </div>
  </div>
  <img *ngIf="cardLogo" [src]="cardLogo" alt="{{ cardType }} logo" class="card-logo" />

